import React from 'react';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import GraficaIMC from './graficaIMC';
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import '../GeneriBascula.js/graficas.css'

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(15),
        border: '1px solid #dadde9',
        marginLeft: '-110%',
        zIndex: 10000,
    },
}))(Tooltip);

export default function Chart({ dataD, fechaIni, fechaFin, valorTotal }) {

 
    const series = [
        dataD[0]?.value1 === undefined ? 0 : dataD[0].value1,
        dataD[1]?.value2 === undefined ? 0 : dataD[1].value2,
        dataD[2]?.value3 === undefined ? 0 : dataD[2].value3,
        dataD[3]?.value4 === undefined ? 0 : dataD[3].value4,
        dataD[4]?.value5 === undefined ? 0 : dataD[4].value5,
        dataD[5]?.value6 === undefined ? 0 : dataD[5].value6,
        dataD[6]?.value7 === undefined ? 0 : dataD[6].value7,
    ];

    return (
        <>
            <Grid container spacing={1} alignItems="center" justifyContent="center">
                <Grid item>
                    <Grid item xs={12} sm container>
                        <Grid item xs container>
                            <Grid item xs>
                                <Grid item xs={12} sm container alignItems="center">
                                    <Grid item xs={12} sm container alignItems="center">
                                        <Typography align="center" style={{ fontWeight: 'bold', fontSize: "30px" }}color='primary'>
                                            Índice de Masa Corporal
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container spacing={2} alignItems="start" justifyContent="center" style={{ marginTop: '0%', marginLeft: "8px", width: '100%', height: '150px' }}>
                <Grid item>
                    <Grid item xs={3} sm container>
                        <Grid item xs container direction="column">
                            <Grid item xs={12} md={12} lg={12}>
                                <GraficaIMC series={series} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={3} style={{ marginLeft: '70%',marginTop:'-19.5%' ,zIndex:500}} className='toltipImc'>
                    <div style={{ display: 'flex', flexDirection: 'column'  }}>
                        <div style={{ marginBottom: '10px' }}>
                            <div style={{ height: '22px' }}>
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"BAJO:"}</b>{' '}
                                            {"Personas con un IMC menor a 18,5."}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{height: '21px' }} color='primary' />
                                </HtmlTooltip>
                            </div>
                            <div style={{ height: '22px' }}>
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"NORMAL:"}</b>{' '}
                                            {"Personas con un IMC entre 18,5 y 25."}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{ height: '21px', zIndex: 9000 }} color='primary' />
                                </HtmlTooltip>
                            </div>
                            <div style={{ height: '22px' }}>
                                            <HtmlTooltip
                                                title={
                                                    <React.Fragment>
                                                        <Typography>Descripción</Typography>
                                                        <b><br />{"SOBREPESO:"}</b>{' '}
                                                        {"Personas con un IMC entre 25 y 30."}
                                                    </React.Fragment>
                                                }
                                                placement="right-start"
                                            >
                                                <HelpOutlineIcon style={{ height: '21px' }} color='primary' />
                                            </HtmlTooltip>
                                        </div>
                            <div style={{ height: '22px' }} >
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"OBESIDAD CLASE I:"}</b>{' '}
                                            {"Personas con un IMC entre 30 y 35."}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{ height: '21px', zIndex: 9000 }} color='primary' />
                                </HtmlTooltip>
                            </div>
                            <div style={{ height: '22px' }}>
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"OBESIDAD CLASE II:"}</b>{' '}
                                            {"Personas con un IMC entre 35 y 40."}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{height: '21px', zIndex: 9000 }} color='primary' />
                                </HtmlTooltip>
                            </div>
                            <div style={{ height: '22px' }}>
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"OBESIDAD CLASE III:"}</b>{' '}
                                            {"Personas con un IMC mayor a 40."}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{height: '21px', zIndex: 9000 }} color='primary' />
                                </HtmlTooltip>
                            </div>
                            <div style={{ height: '22px' }}>
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"SIN REGISTRO:"}</b>{' '}
                                            {"Usuarios que no se han realizado las mediciones de peso y altura."}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{height: '21px', zIndex: 9000 }} color='primary' />
                                </HtmlTooltip>
                            </div>
                        </div>
                    </div>
                </Grid>
            </Grid>
        </>
    );
}
